// extracted by mini-css-extract-plugin
module.exports = {"overlay":"index_overlay__evp1G","modal":"index_modal___PFKW","wrap-auth":"index_wrap-auth__tetcw","button-back":"index_button-back__TVWlQ"};